/**
 * Where the product photos come from — the one knob for the whole SPA.
 *
 * Korgun stores no image data, only Windows paths into the factory's file
 * share; the files are copied out of that share into the R2 bucket and the
 * Worker serves them at `/api/images/<key>` (see worker/api/images.ts). Until
 * that upload has happened the base stays `null`: `imageUrl` then answers null
 * for every key and `<ProductImage>` draws its placeholder WITHOUT issuing a
 * request, so a fifty-row list does not spend fifty round trips on 404s.
 *
 * Switching the photos on is this one line — `'/api/images'` (same origin, so
 * the session cookie rides along on its own) or a public bucket URL.
 */
const IMAGE_BASE: string | null = null

/** R2 object key → URL, or null while there is nothing to read the photo from. */
export function imageUrl(key: string): string | null {
  return IMAGE_BASE === null ? null : `${IMAGE_BASE}/${encodeURIComponent(key)}`
}
